import { render, staticRenderFns } from "./TaskUpdated.vue?vue&type=template&id=21540e1d"
import script from "./TaskUpdated.vue?vue&type=script&lang=js"
export * from "./TaskUpdated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports